export default __webpack_public_path__ + "static/media/CreerUnJeu-1.4d8be762.png";